import {Pipe} from "@angular/core";

@Pipe({name: "sortByBankName"})
export class SortByBankNamePipe {

  constructor(){

  }

  static _orderByComparator(a:any, b:any, sortKey:any):number{

    if(a === null || typeof a === 'undefined') a = 0;
    if(b === null || typeof b === 'undefined') b = 0;

    if(sortKey === 'asc'){
      if((!isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))){
        //Isn't a number so lowercase the string to properly compare
        if(a.toLowerCase() < b.toLowerCase()) return -1;
        if(a.toLowerCase() > b.toLowerCase()) return 1;
      }
      else{
        //Parse strings as numbers to compare properly
        if(parseFloat(a) < parseFloat(b)) return -1;
        if(parseFloat(a) > parseFloat(b)) return 1;
      }
    } else {
      if((!isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))){
        //Isn't a number so lowercase the string to properly compare
        if(a.toLowerCase() > b.toLowerCase()) return -1;
        if(a.toLowerCase() < b.toLowerCase()) return 1;
      }
      else{
        //Parse strings as numbers to compare properly
        if(parseFloat(a) > parseFloat(b)) return -1;
        if(parseFloat(a) < parseFloat(b)) return 1;
      }
    }


    return 0; //equal each other
  }

  transform(array: Array<string>, args: any): Array<string> {
    if(args.name !== ''){
      array.sort((a: any, b: any) => {
        if(args.name === 'bankName'){
          return SortByBankNamePipe._orderByComparator(a._id[args.name], b._id[args.name], args.sort)
        } else {
          return SortByBankNamePipe._orderByComparator(a._id[args.name], b._id[args.name], args.sort)
        }
      });
    }


    return array;
  }
}

@Pipe({name: "sortByBankNameWithdraw"})
export class SortByBankNameWithdrawPipe {

  constructor(){

  }

  static _orderByComparator(a:any, b:any, sortKey:any):number{

    if(a === null || typeof a === 'undefined') a = 0;
    if(b === null || typeof b === 'undefined') b = 0;

    if(sortKey === 'asc'){
      if((!isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))){
        //Isn't a number so lowercase the string to properly compare
        if(a.toLowerCase() < b.toLowerCase()) return -1;
        if(a.toLowerCase() > b.toLowerCase()) return 1;
      }
      else{
        //Parse strings as numbers to compare properly
        if(parseFloat(a) < parseFloat(b)) return -1;
        if(parseFloat(a) > parseFloat(b)) return 1;
      }
    } else {
      if((!isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))){
        //Isn't a number so lowercase the string to properly compare
        if(a.toLowerCase() > b.toLowerCase()) return -1;
        if(a.toLowerCase() < b.toLowerCase()) return 1;
      }
      else{
        //Parse strings as numbers to compare properly
        if(parseFloat(a) > parseFloat(b)) return -1;
        if(parseFloat(a) < parseFloat(b)) return 1;
      }
    }


    return 0; //equal each other
  }

  transform(array: Array<string>, args: any): Array<string> {
    if(args.name !== ''){
      array.sort((a: any, b: any) => {
        if(args.name === 'bankSet'){
          return SortByBankNamePipe._orderByComparator(a._id[args.name], b._id[args.name], args.sort)
        } else {
          return SortByBankNamePipe._orderByComparator(a._id[args.name], b._id[args.name], args.sort)
        }
      });
    }


    return array;
  }
}

@Pipe({name: "sortByAmount"})
export class SortByAmount {

  constructor(){

  }

  static _orderByComparator(a:any, b:any, sortKey:any):number{

    if(a === null || typeof a === 'undefined') a = 0;
    if(b === null || typeof b === 'undefined') b = 0;

    if(sortKey === 'asc'){
      if((!isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))){
        //Isn't a number so lowercase the string to properly compare
        if(a.toLowerCase() < b.toLowerCase()) return -1;
        if(a.toLowerCase() > b.toLowerCase()) return 1;
      }
      else{
        //Parse strings as numbers to compare properly
        if(parseFloat(a) < parseFloat(b)) return -1;
        if(parseFloat(a) > parseFloat(b)) return 1;
      }
    } else {
      if((!isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))){
        //Isn't a number so lowercase the string to properly compare
        if(a.toLowerCase() > b.toLowerCase()) return -1;
        if(a.toLowerCase() < b.toLowerCase()) return 1;
      }
      else{
        //Parse strings as numbers to compare properly
        if(parseFloat(a) > parseFloat(b)) return -1;
        if(parseFloat(a) < parseFloat(b)) return 1;
      }
    }


    return 0; //equal each other
  }

  transform(array: Array<string>, args: any): Array<string> {
    if(args.name !== ''){
      array.sort((a: any, b: any) => {
        if(args.name === 'amount'){
          return SortByBankNamePipe._orderByComparator(a[args.name], b[args.name], args.sort)
        } else {
          return SortByBankNamePipe._orderByComparator(a[args.name], b[args.name], args.sort)
        }
      });
    }


    return array;
  }
}



// WEBPACK FOOTER //
// /Users/pakornduangtrakan/Snocko/other/backend-auto/src/app/_services/pip.ts